module.exports = __webpack_public_path__ + "static/media/IMG_8917.25c0906d.JPG";